{
	"about": {
		"build-number": "Número de construcción",
		"title": "Acerca de",
		"version": "Versión",
		"new-version": "Nueva versión"
	},
	"legal": {
		"privacy-policy": "Política de Privacidad",
		"terms-of-use": "Términos de Uso"
	}
}
